module.exports = __webpack_public_path__ + "img/0Q3A2889_L_Black.6754bf92.jpg";